'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".RadioCard-module_radioContainer__dQNKB{flex-shrink:0;line-height:1}";
var styles = {"radioContainer":"RadioCard-module_radioContainer__dQNKB"};
styleInject["default"](css_248z, '15ae9634-e60c-41b6-b025-e2cbd9db0b6b');

exports["default"] = styles;
